var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDisable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.25H16.5C18.2902 0.25 20.0071 0.961159 21.273 2.22703C22.5388 3.4929 23.25 5.20979 23.25 7C23.25 8.79021 22.5388 10.5071 21.273 11.773C20.0071 13.0388 18.2902 13.75 16.5 13.75H7.5C5.70979 13.75 3.9929 13.0388 2.72703 11.773C1.46116 10.5071 0.75 8.79021 0.75 7C0.75 5.20979 1.46116 3.4929 2.72703 2.22703C3.9929 0.961159 5.70979 0.25 7.5 0.25ZM16.5 10.75C17.2417 10.75 17.9667 10.5301 18.5834 10.118C19.2001 9.70596 19.6807 9.12029 19.9645 8.43506C20.2484 7.74984 20.3226 6.99584 20.1779 6.26841C20.0333 5.54098 19.6761 4.8728 19.1517 4.34835C18.6272 3.8239 17.959 3.46675 17.2316 3.32205C16.5042 3.17736 15.7502 3.25162 15.0649 3.53545C14.3797 3.81928 13.794 4.29993 13.382 4.91661C12.9699 5.5333 12.75 6.25832 12.75 7C12.75 7.99456 13.1451 8.94839 13.8483 9.65165C14.5516 10.3549 15.5054 10.75 16.5 10.75Z",
    fill: "#585960"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisable);
export default __webpack_public_path__ + "static/media/disable.a7b9cc0e015958a780c9f4371a2bc502.svg";
export { ForwardRef as ReactComponent };